import Vue from "vue";
import CertificateMapping from "./certificateMapping";
import CertificateMappedFormElementContainer from "./certificateMappedFormElementContainer";

export default class CertificateMappedFormElementContainerFactory {
  static create(mapping: CertificateMapping, json: object = {}): CertificateMappedFormElementContainer {
    const formElementContainer = new CertificateMappedFormElementContainer(mapping, json);
    formElementContainer.parent = mapping;
    formElementContainer.rootModel = mapping.rootModel;

    Vue.set(mapping.mapped_form_element_containers, formElementContainer.client_id, formElementContainer);

    CertificateMappedFormElementContainer.repo.add(formElementContainer);

    mapping.trackCreationDeletion(formElementContainer.client_id, null, formElementContainer.asJson(), formElementContainer);

    return formElementContainer;
  }

  static remove(formElementContainer: CertificateMappedFormElementContainer) {
    CertificateMappedFormElementContainer.repo.remove(formElementContainer);
    formElementContainer.destroy();
  }
}